export default __webpack_public_path__ + "static/automate-dont-1-68fa71d710c59000ce15103966897d55.png";